var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDonutYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.882,
    height: 69.869,
    viewBox: "0 0 69.882 69.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_31360",
    "data-name": "Path 31360",
    d: "M659.709,273.01a34.935,34.935,0,1,1,34.941-34.935A34.977,34.977,0,0,1,659.709,273.01Zm0-62.869a27.935,27.935,0,1,0,27.941,27.935A27.969,27.969,0,0,0,659.709,210.141Z",
    transform: "translate(-624.768 -203.141)",
    fill: "#fece01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonutYellow);
export default __webpack_public_path__ + "static/media/donut_yellow.13f1b61dab6908f6cc6815033d1c223e.svg";
export { ForwardRef as ReactComponent };